/** @format */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'homefield-recommendation-card',
  templateUrl: './recommendation-card.component.html',
  styleUrl: './recommendation-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomeFieldRecommendationCardComponent {
  @Input() link: string;
  @Input() imgSrc: string;
  @Input() title: string;
  @Input() minOriginalPrice;
  @Input() maxOriginalPrice;
  @Input() minPrice;
  @Input() maxPrice;
  @Input() isSeePriceInCart: boolean;
  @Input() ecode: string;
  @Input() color: string;
  @Input() dataEm: string;
}
